import { render, staticRenderFns } from "./AlertUserSelector.vue?vue&type=template&id=459a654b&scoped=true"
import script from "./AlertUserSelector.vue?vue&type=script&lang=js"
export * from "./AlertUserSelector.vue?vue&type=script&lang=js"
import style0 from "./AlertUserSelector.vue?vue&type=style&index=0&id=459a654b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a654b",
  null
  
)

export default component.exports